import { Document, Font, Page, StyleSheet, Text } from '@react-pdf/renderer';
import type { PageProps } from '@react-pdf/renderer';
import type { ReactElement, ReactNode } from 'react';

import type { Quote } from '@core/types/api/Quote/Quote';

import defaultHyphenation from './components/defaultHyphenation';
import { RegisterFonts } from './Fonts';

RegisterFonts();

const styles = StyleSheet.create({
  page: {
    padding: '0.75in',
  },
  pageNumber: {
    alignSelf: 'center',
    width: '100%',
    paddingTop: '0.5in',
    textAlign: 'right',
    fontSize: '8pt',
    fontFamily: 'Helvetica-Bold',
    position: 'absolute',
  },
});

type QuotePdfProps = {
  children: ReactNode;
  quote: Quote;
  pageStyle?: PageProps;
  /** @default false */
  disableHyphenation?: boolean;
  /** @default false */
  includePageNumbers?: boolean;
};

export const QuotePdf = ({
  children,
  quote,
  pageStyle,
  disableHyphenation = false,
  includePageNumbers = false,
}: QuotePdfProps): ReactElement => {
  if (disableHyphenation) {
    Font.registerHyphenationCallback((word) => [word]);
  } else {
    Font.registerHyphenationCallback(defaultHyphenation());
  }
  const ps = [pageStyle?.style ?? {}].flat();
  return (
    <Document title={quote.name ?? undefined}>
      <Page style={[styles.page, ...ps]}>
        {includePageNumbers && (
          <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }): string => `page ${pageNumber} of ${totalPages}`}
            fixed
          />
        )}
        {children}
      </Page>
    </Document>
  );
};
